"use client";

import { useTranslations } from 'next-intl';

export function HeaderThumbnailSkeleton() {
  const t = useTranslations('common');
  return (
    <div role="status" aria-busy="true" aria-label={t('loading')} className="flex h-full items-center gap-px overflow-hidden">
      {Array.from({ length: 8 }, (_, i) => (
        <div key={i} aria-hidden="true" className="size-[var(--header-height)] flex-shrink-0 bg-muted motion-safe:animate-pulse" />
      ))}
    </div>
  );
}
